// extracted by mini-css-extract-plugin
export default {"isSystemAdminContainer":"WebActivation_isSystemAdminContainer__NFavf","createPassButton":"WebActivation_createPassButton__BTySK"};